const log = {
  data () {
    return {
      loggingEnabled: false
    }
  },
  methods: {
    log () {
      if (this.loggingEnabled) {
        console.log(...Object.values(arguments)); // eslint-disable-line
      }
    }
  }
}

export default log
